import React from 'react'

import Card from '../layout/Card'
import ProgressBar from '../layout/ProgressBar'

type BoxProgressProps = { progress: number, children: React.ReactNode }
const BoxProgress: React.FC<BoxProgressProps> = ({ progress, children }) => (
  <div className='flex items-center justify-center'>
    <Card className='w-full bg-soft-green px-4 lg:px-8 py-6'>
      <ProgressBar progress={progress} progressColor='deep-green' bgColor='white'/>
      {children}
    </Card>
  </div>
)

export default BoxProgress
